<script setup lang="ts">
  import { CrossCircle, Search } from '@logistiek-zonder-papier/lzp-library'

  const value = defineModel<string | undefined>()
</script>

<template>
  <div class="column-search">
    <Search class="search-icon" />
    <input v-model="value" type="search" class="search-input" />
    <CrossCircle v-if="value" class="clear-icon" @click="value = ''" />
  </div>
</template>

<style scoped>
  .column-search {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    padding: 0.25rem 0;
    border-bottom: 1px solid var(--colours-grey-3);
    color: var(--colours-grey-4);
  }

  .search-icon,
  .clear-icon {
    flex: 0 0 auto;
    width: 1rem;
    height: 1rem;
  }

  .clear-icon {
    cursor: pointer;
  }

  .search-input {
    flex: 1 1 auto;
    min-width: 0;
    border: none;
    outline: none;
    background: transparent;
    font-size: 0.875rem;
    font-weight: 400;
    color: var(--colours-grey-5);
    padding: 0;
  }

  .search-input::-webkit-search-cancel-button {
    display: none;
  }
</style>
